import Cookie from 'js-cookie'
import { ChatKitSessionResponse } from '../types'

const COOKIE_KEY = 'ai_session'
const COOKIE_THREAD_ID_KEY = 'ai_thread_id'

const cookieGuard = (value: unknown): value is ChatKitSessionResponse => {
  if (!value || typeof value !== 'object') return false

  const obj = value as Record<string, unknown>

  return typeof obj.clientSecret === 'string' && typeof obj.expiresAt === 'number'
}

export const getAICookie = () => {
  try {
    const cookie = Cookie.get(COOKIE_KEY)

    if (!cookie) return undefined

    const parsed = JSON.parse(cookie)

    if (cookieGuard(parsed)) {
      return parsed
    }

    return undefined
  } catch {
    return undefined
  }
}

export const setAICookie = (data: ChatKitSessionResponse) =>
  Cookie.set(COOKIE_KEY, JSON.stringify(data))

export const setThreadIdCookie = (threadId: string) => Cookie.set(COOKIE_THREAD_ID_KEY, threadId)

export const removeThreadIdCookie = () => Cookie.remove(COOKIE_THREAD_ID_KEY)

export const getThreadIdCookie = () => Cookie.get(COOKIE_THREAD_ID_KEY) ?? null
